import { css } from '@emotion/react';

export const dropdownGlobalStyles = css`
  .custom-ant-dropdown .ant-dropdown-menu {
    padding: 4px 0;
  }
`;
